module.exports = "/media/down_black.7df9463e.png";